import { render, staticRenderFns } from "./SedimentPlot.vue?vue&type=template&id=5cb51296&scoped=true"
import script from "./SedimentPlot.vue?vue&type=script&lang=js"
export * from "./SedimentPlot.vue?vue&type=script&lang=js"
import style0 from "./SedimentPlot.vue?vue&type=style&index=0&id=5cb51296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb51296",
  null
  
)

export default component.exports